import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import AdminCompanyBilling from "../components/AdminCompanyBilling";
import * as companyActions from "../../../../actions/company.actions";
import * as invoiceActions from "../../../../actions/invoice.actions";

class AdminCompanyBillingContainer extends Component {
  constructor(props) {
    super(props);

    this.downloadInvoice = this.downloadInvoice.bind(this);
  }

  componentDidMount() {
    this.props.companyActions.getAdminCompanyById(
      this.props.match.params.companyId
    );
  }

  downloadInvoice(invoiceId) {
    this.props.invoiceActions.downloadInvoice(invoiceId);
  }

  render() {
    return (
      <AdminCompanyBilling
        id={this.props.match.params.companyId}
        company={this.props.company}
        projects={this.props.projects}
        feed={this.props.feed}
        downloadInvoice={this.downloadInvoice}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    company: state.company.adminCompany,
    projects: state.company.adminCompany.projects,
    feed: state.company.adminCompany.feed
  };
};

const mapDispatchToProps = dispatch => ({
  companyActions: bindActionCreators(companyActions, dispatch),
  invoiceActions: bindActionCreators(invoiceActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCompanyBillingContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/company/containers/AdminCompanyBillingContainer.js